import React from 'react';
import { useGetPermissions } from 'layouts/customHook';
import { PermisionDenied } from 'views/pages/manage/common/commonComponents';
import OutstandingDashboard from './OutstandingDashboard';

const OutstandingWrapper=()=>{
      const userPermissions = useGetPermissions('outstandingfees');

    return userPermissions ? (
        <OutstandingDashboard
            userPermissions={userPermissions}
        />
    ) : (
        <PermisionDenied />
    );

}

export default OutstandingWrapper;